import { useState, useEffect } from 'react'

interface ScrollTransformOptions {
  translateY?: {
    hidden: string
    visible: string
  }
  transition?: string
}

const useScrollTransform = (options: ScrollTransformOptions = {}) => {
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down'>('up')
  const [lastScrollY, setLastScrollY] = useState(0)
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight

      if (currentScrollY >= 200 && currentScrollY <= maxScroll - 200 && Math.abs(currentScrollY - lastScrollY) > 5) {
        setScrollDirection(currentScrollY > lastScrollY ? 'down' : 'up')
        setLastScrollY(currentScrollY)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [lastScrollY])

  const transformStyles = {
    transition: options.transition || 'transform 0.15s ease!important',
    transform: options.translateY
      ? scrollDirection === 'down'
        ? `translateY(${options.translateY.hidden})`
        : `translateY(${options.translateY.visible})`
      : undefined,
  }

  return { scrollDirection, transformStyles }
}

export default useScrollTransform
